module.exports = __webpack_public_path__ + "img/meshulash_no.edea3249.png";